var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3V0.75L3 3.75L6 6.75V4.5C8.4825 4.5 10.5 6.5175 10.5 9C10.5 9.7575 10.3125 10.4775 9.975 11.1L11.07 12.195C11.655 11.2725 12 10.1775 12 9C12 5.685 9.315 3 6 3ZM6 13.5C3.5175 13.5 1.5 11.4825 1.5 9C1.5 8.2425 1.6875 7.5225 2.025 6.9L0.93 5.805C0.345 6.7275 0 7.8225 0 9C0 12.315 2.685 15 6 15V17.25L9 14.25L6 11.25V13.5Z",
    fill: "#4E78F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.d7d39bfdaa1b5e3bb12cb050221a1c0a.svg";
export { ForwardRef as ReactComponent };